import React, { useMemo } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { useDeckardStripe } from './Stripe';
import { PAYMENT_METHODS } from '../constants';
import StripeCreditCard from './StripeCreditCard';
import StripeACH from './StripeACH';

const StripePayment = ({ flow, paymentMethod, onPay }) => {
  const stripe = useDeckardStripe(flow);

  const form = useMemo(() => {
    if (paymentMethod === PAYMENT_METHODS.ACH_DIRECT_DEBIT) {
      return <StripeACH onSuccess={onPay} />;
    } else if (paymentMethod === PAYMENT_METHODS.CREDIT_OR_DEBIT__CARD) {
      return <StripeCreditCard onSuccess={onPay} />;
    }
    return <></>;
  }, [paymentMethod, onPay]);

  if (!stripe) {
    return <div data-testid="stripe-element-component" />;
  }

  return (
    <Elements stripe={stripe}>
      <div data-testid="stripe-element-component">{form}</div>
    </Elements>
  );
};

export default StripePayment;
